import { useCallback } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { CheckboxGroupProps } from 'react-rainbow-components/components/CheckboxGroup';
import CheckBoxGroupFilter, { CheckBoxGroupFilterLabel } from 'components/CheckBoxGroupFilter';

interface Params extends Omit<CheckboxGroupProps, 'value' | 'onChange'> {
    value?: string[] | null;
    onChange?: (values: string[] | null) => void;
}

const languages = [
    {
        name: 'en',
        label: 'English',
    },
    {
        name: 'es',
        label: 'Spanish',
    },
];

const LanguageFilter = (props: Params) => {
    const {
        value: valueInProps,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);

    const options = languages.map(
        (language) => ({
            value: language.name,
            label: <CheckBoxGroupFilterLabel>{language.label}</CheckBoxGroupFilterLabel>,
        }),
    );

    const value = valueInProps ?? [];

    const handleOnChange = useCallback(
        (values: string[]) => {
            if (!values?.length) return onChange(null);
            return onChange(values);
        },
        [onChange],
    );

    return (
        <CheckBoxGroupFilter
            {...rest}
            hideLabel
            options={options}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default LanguageFilter;
